import { getTop10, getBottom5 } from '../utils/similarity';

export interface TeamMember {
  id: string;
  talents: string[];
  top10: string[];
  bottom5: string[];
}

let cachedMembers: TeamMember[] | null = null;

export async function loadTeamData(csvPath: string = '/data/team-talents.csv'): Promise<TeamMember[]> {
  if (cachedMembers) return cachedMembers;

  const response = await fetch(csvPath);
  if (!response.ok) {
    throw new Error(`无法加载团队数据: ${response.status}`);
  }

  const text = await response.text();
  const lines = text.trim().split(/\r?\n/);
  if (lines.length < 2) {
    throw new Error('CSV 数据为空或格式不正确');
  }

  const members: TeamMember[] = [];
  for (let i = 1; i < lines.length; i++) {
    const cols = parseCSVLine(lines[i]);
    if (cols.length < 36) continue;

    const talents = cols.slice(2, 36);
    members.push({
      id: `m${i - 1}`,
      talents,
      top10: getTop10(talents),
      bottom5: getBottom5(talents),
    });
  }

  cachedMembers = members;
  return members;
}

function parseCSVLine(line: string): string[] {
  const result: string[] = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (inQuotes) {
      if (ch === '"') {
        if (i + 1 < line.length && line[i + 1] === '"') {
          current += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        current += ch;
      }
    } else {
      if (ch === '"') {
        inQuotes = true;
      } else if (ch === ',') {
        result.push(current.trim());
        current = '';
      } else {
        current += ch;
      }
    }
  }
  result.push(current.trim());
  return result;
}
